var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "input-name-slug" } }, [
    _c("div", { staticClass: "md-form mt-1 mb-0" }, [
      _c("i", { staticClass: "material-icons prefix" }, [_vm._v("title")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.input_name__value,
            expression: "input_name__value"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          id: _vm.input_name__id,
          name: _vm.input_name__name,
          readonly: _vm.input_name__disabled == 1,
          required: "",
          "aria-required": "true",
          autocomplete: "off"
        },
        domProps: { value: _vm.input_name__value },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.input_name__value = $event.target.value
            },
            function($event) {
              _vm.testSlug(true)
            }
          ]
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          class: _vm.input_name__active,
          attrs: {
            for: _vm.input_name__id,
            "data-error": "wrong",
            "data-right": "correct"
          }
        },
        [_vm._v("Name")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "md-form mt-1 mb-0" }, [
      _c("i", { staticClass: "material-icons prefix" }, [
        _vm._v("insert_link")
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.input_slug__value,
            expression: "input_slug__value"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          id: _vm.input_slug__id,
          name: _vm.input_slug__name,
          readonly: _vm.input_slug__disabled == 1,
          required: "",
          "aria-required": "true",
          autocomplete: "off"
        },
        domProps: { value: _vm.input_slug__value },
        on: {
          change: function($event) {
            _vm.testSlug(false)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.input_slug__value = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "active",
          class: _vm.input_slug__active,
          attrs: {
            for: _vm.input_slug__id,
            "data-error": "wrong",
            "data-right": "correct"
          }
        },
        [_vm._v("Slug")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e087dc8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e087dc8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/forms/NameToSlug.vue
// module id = 301
// module chunks = 0